import React from 'react'
import Helmet from 'react-helmet'
import AppState from '../state/AppState';
import '../scss/main.css'
import { SEO_DEFAULTS } from '../constants'
const { TITLE, DESCRIPTION, KEYWORDS } = SEO_DEFAULTS;
import {getMyUser} from '../api';

/*
This layout is applied to any page in the "pages" folder.
 */

class Basic extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    getMyUser({ withorgs: 0, withsettings: 0 }).then((result) => {
      AppState.setUser(result.user);

      if (typeof FS !== "undefined")
        FS.identify(result.user.id, {
          email: result.user.email,
          gf_premium: result.user.gf_premium,
          customer_id: result.user.customer_id
        });

    }).catch((e) => {
      if (e && e.status !== 401) {}
    });
  }

  render() {

    const { children } = this.props;

    return (
      <div className="">
        <Helmet title={TITLE} meta={this.getMetaData()} />
        {children()}
      </div>
    )
  }

  getMetaData() {
    return [
      { name: 'description', content: DESCRIPTION },
      { name: 'keywords', content: KEYWORDS  }
    ];
  }

}

export default Basic;




// WEBPACK FOOTER //
// ./src/layouts/index.js